import Card from 'components/card';
import { MdHelpOutline, MdOutlineQuestionAnswer } from 'react-icons/md';

const faqData = [
    {
        category: "Questions sur l'inscription et le compte",
        questions: [
            {
                q: 'Comment créer un compte acheteur sur la plateforme ?',
                a: "Pour créer un compte acheteur, vous devez vous rendre sur la page d'inscription de la plateforme. Vous devrez choisir un abonnement et remplir les informations demandées, telles que votre nom, prénom, adresse e-mail, et créer un mot de passe sécurisé. Une fois l'inscription terminée, vous recevrez un e-mail de confirmation pour valider votre compte.",
            },
            {
                q: "Est-ce que l'inscription est gratuite ?",
                a: "L'inscription n'est pas gratuite. Le coût de l'inscription dépend de l'abonnement que vous choisissez. Chaque abonnement offre différents niveaux d'accès aux services de la plateforme, avec des fonctionnalités et des tarifs variés en fonction de vos besoins.",
            },
            {
                q: 'Quels documents ou informations dois-je fournir pour acheter des leads ?',
                a: "Lors de l'achat de leads, vous devrez compléter un processus de vérification KYC (Know Your Customer), qui peut inclure la soumission de documents d'identité et d'autres informations personnelles. Vous devrez également signer une charte de responsabilité, confirmant que vous respecterez les lois en vigueur concernant l’utilisation des leads.",
            },
            {
                q: 'Comment modifier mes informations de compte (email, coordonnées bancaires, etc.) ?',
                a: "Pour modifier vos informations de compte, connectez-vous à votre compte et accédez à la section 'Mon compte'. Vous y trouverez les options pour mettre à jour votre adresse e-mail, vos coordonnées bancaires et d'autres informations personnelles.",
            },
            {
                q: "Comment supprimer mon compte acheteur si je ne souhaite plus l'utiliser ?",
                a: "Si vous souhaitez supprimer votre compte, vous pouvez le faire directement depuis la section 'Mon compte'. Vous y trouverez une option pour supprimer votre compte. Une fois supprimé, toutes les informations associées à votre compte seront effacées, sauf celles requises par la législation en vigueur.",
            },
        ],
    },
    {
        category: "Questions sur l'achat de leads",
        questions: [
            {
                q: 'Comment acheter des leads sur la plateforme ?',
                a: "Pour acheter des leads, connectez-vous à votre compte et accédez à la section dédiée à l'achat de leads. Vous pourrez y consulter différentes catégories de leads, choisir ceux qui vous intéressent et procéder au paiement en ligne pour finaliser votre achat.",
            },
            {
                q: 'Où puis-je consulter les offres de leads disponibles ?',
                a: "Les offres de leads sont accessibles dans la section 'Marketplace' de la plateforme. Vous y trouverez une variété de leads classés par catégories, industries, et critères de ciblage.",
            },
            {
                q: 'Comment savoir si un lead correspond à mes critères ou besoins ?',
                a: "Avant d'acheter un lead, vous pouvez consulter les détails de chaque lead, y compris les informations de qualification, les critères de recherche et les préférences. Cela vous permet de vérifier si le lead correspond à vos besoins. Si nécessaire, vous pouvez affiner vos critères de recherche pour mieux cibler vos achats.",
            },
            {
                q: 'Est-ce que je peux demander des leads personnalisés ?',
                a: "Oui, vous pouvez demander des leads personnalisés. La plateforme propose un service sur mesure où vous pouvez spécifier des critères très précis pour obtenir des leads qui répondent exactement à vos besoins. Vous pouvez soumettre votre demande via la section 'Mon compte' ou en contactant notre support.",
            },
            {
                q: 'Puis-je acheter des leads en grande quantité ?',
                a: "Oui, vous pouvez acheter des leads en grande quantité. La plateforme permet aux acheteurs d'acquérir des lots de leads selon leurs besoins. Si vous avez des exigences spécifiques concernant la quantité ou le type de leads, vous pouvez également contacter notre support pour discuter d'une offre personnalisée.",
            },
            {
                q: 'Quelle est la différence entre un lead exclusif et un lead non exclusif ?',
                a: 'Un lead exclusif est un lead qui est vendu à un seul acheteur, garantissant ainsi que vous êtes le seul à avoir accès à ces informations. Un lead non exclusif, en revanche, peut être vendu à plusieurs acheteurs, ce qui signifie que d’autres personnes peuvent également acheter ce même lead.',
            },
            {
                q: 'Comment puis-je savoir si les leads sont récents et de qualité ?',
                a: 'Les leads disponibles sur la plateforme sont vérifiés pour garantir leur qualité et leur instantanéité. Chaque lead est mis à jour régulièrement et vous pouvez consulter la date de création ou de mise à jour de chaque lead. Vous aurez aussi accès à des informations détaillées sur la qualification de chaque lead pour évaluer sa pertinence.',
            },
            {
                q: 'Quand vais-je recevoir mes leads ?',
                a: 'Les leads sont généralement envoyés immédiatement après la validation de votre paiement. Vous recevrez un e-mail de confirmation, et les informations relatives aux leads achetés seront disponibles dans votre espace personnel sur la plateforme. Dans certains cas, si des leads personnalisés ont été demandés, cela peut prendre un peu plus de temps en fonction des critères spécifiques définis.',
            },
            {
                q: "Comment respecter la législation en vigueur lors de l'utilisation des leads ?",
                a: "Les leads que vous achetez via la plateforme doivent être utilisés conformément à la législation en vigueur, notamment en ce qui concerne la protection des données personnelles et les pratiques commerciales. Il est de votre responsabilité en tant qu'acheteur de vous assurer que vous respectez les lois locales et internationales sur la gestion et le traitement des données. En vous inscrivant et en achetant des leads sur la plateforme, vous vous engagez à respecter toutes les réglementations légales en vigueur.",
            },
        ],
    },
    {
        category: 'Questions sur les prix et les paiements',
        questions: [
            {
                q: 'Comment sont fixés les prix des leads ?',
                a: "Les prix des leads sont déterminés en fonction de plusieurs critères, notamment le type de lead (exclusif ou non exclusif), le secteur d'activité, le niveau de qualification du lead, ainsi que la demande pour ces types de données. Les prix peuvent varier selon l'abonnement de l'utilisateur et la quantité de leads achetés.",
            },
            {
                q: 'Existe-t-il des réductions pour les achats en grande quantité ?',
                a: "Non, il n'existe pas de réductions spécifiques pour les achats en grande quantité. Les prix sont fixés en fonction du type de lead et de la demande, mais des options personnalisées peuvent être proposées selon votre profil d'acheteur.",
            },
            {
                q: 'Quels modes de paiement sont acceptés sur la plateforme ?',
                a: 'Actuellement, nous acceptons les paiements par carte bancaire (Visa, MasterCard, etc.), et bientôt, nous ajouterons également le virement bancaire et les paiements en cryptomonnaie comme options disponibles.',
            },
            {
                q: 'Quand et comment suis-je facturé pour mes achats de leads ?',
                a: 'Vous recevrez la facture à la fin de la mission, une fois que les leads auront été livrés et que la transaction aura été complétée. La facture sera envoyée par e-mail et sera également disponible dans votre espace personnel sur la plateforme.',
            },
            {
                q: 'Puis-je acheter des leads au coût unitaire ?',
                a: "Non, l'achat minimum est pour le moment de 50 leads. Vous ne pouvez pas acheter de leads à l'unité, mais nous proposons des lots de 50 leads ou plus pour répondre à vos besoins.",
            },
            {
                q: 'Y a-t-il un montant minimum ou maximum que je peux acheter ?',
                a: "Le montant minimum d'achat est de 50 leads, et il n'y a pas de limite maximale tant que les leads sont disponibles. Vous pouvez acheter un volume plus important si nécessaire.",
            },
            {
                q: 'Est-ce que les prix des leads sont négociables ?',
                a: 'Les prix des leads ne sont généralement pas négociables, car ils sont fixés en fonction de la demande et des critères de qualification. Toutefois, des offres personnalisées peuvent être envisagées pour des achats en grande quantité ou pour des abonnements à long terme.',
            },
        ],
    },
    {
        category: 'Questions sur la qualité des leads',
        questions: [
            {
                q: 'Comment la plateforme garantit-elle la qualité des leads ?',
                a: "La qualité des leads est garantie par un processus de vérification rigoureux. Nous effectuons des contrôles pour nous assurer que les informations sont récentes, pertinentes et qualifiées selon des critères spécifiques. De plus, nous mettons à jour régulièrement notre base de données pour garantir l'instantanéité des leads.",
            },
            {
                q: 'Que faire si un lead ne correspond pas à mes attentes ou critères ?',
                a: 'Si un lead ne correspond pas à vos attentes ou critères, nous vous encourageons à contacter notre service client. Nous examinerons votre demande et, selon la situation, nous pourrons vous offrir un remboursement ou un remplacement du lead si celui-ci ne répond pas aux spécifications que vous avez fournies.',
            },
            {
                q: "Puis-je demander un remboursement ou un remplacement pour un lead qui n'est pas valide ?",
                a: "Oui, vous pouvez demander un remboursement ou un remplacement pour un lead qui n'est pas valide, à condition que celui-ci ne respecte pas les critères définis lors de votre commande. Vous devrez fournir les informations nécessaires pour permettre une vérification rapide de votre demande. Les conditions de remboursement ou remplacement seront spécifiées dans nos conditions générales de vente.",
            },
            {
                q: 'Quelles informations sont fournies sur chaque lead acheté ?',
                a: "Chaque lead que vous achetez comprend des informations détaillées, telles que le nom, l'adresse e-mail, le numéro de téléphone, ainsi que d'autres données spécifiques liées à l'activité ou aux intérêts du prospect. Le niveau de détail peut varier en fonction du type de lead et des critères que vous avez définis lors de votre commande.",
            },
        ],
    },
    {
        category: 'Questions sur la livraison des leads',
        questions: [
            {
                q: 'Comment les leads sont-ils livrés une fois achetés ?',
                a: "Une fois vos leads achetés, ils vous sont envoyés automatiquement pour garantir leur instantanéité. Vous pouvez les recevoir directement par e-mail à l'adresse que vous avez indiquée lors de votre inscription.",
            },
            {
                q: 'Est-ce que les leads sont envoyés automatiquement ou dois-je faire une demande ?',
                a: "Les leads sont envoyés automatiquement dès la réception de votre commande et du paiement. Cela permet de garantir leur instantanéité. Vous n'avez pas besoin de faire une demande manuelle, ils seront directement envoyés.",
            },
            {
                q: 'Y a-t-il un délai de livraison pour recevoir mes leads ?',
                a: 'Les leads sont envoyés immédiatement après la validation de votre commande et paiement selon la disponibilité et le type de leads. Le délai de livraison peut varier entre 1 semaine et 1 mois.',
            },
            {
                q: 'Comment suivre l’évolution des leads que j’ai achetés ?',
                a: "Vous pouvez suivre l'évolution de vos achats de leads directement depuis votre dashboard. Ce dernier vous permet de voir l'état de vos commandes et d'accéder aux informations actualisées concernant vos leads.",
            },
            {
                q: 'Est-ce que je peux recevoir les leads par email, API ou un autre format ?',
                a: "Oui, vous pouvez recevoir vos leads par e-mail ou les intégrer directement dans votre CRM via les intégrations proposées par la plateforme. De plus, les leads peuvent également être envoyés sur Google Sheets (GSheet) si vous préférez ce format. Tout cela dépend de l'option que vous choisissez lors de votre commande.",
            },
        ],
    },
    {
        category: "Questions sur l'intégration et l'utilisation des leads",
        questions: [
            {
                q: 'Puis-je intégrer les leads achetés dans mon CRM ?',
                a: "Oui, la plateforme propose des intégrations avec plusieurs CRM, ce qui vous permet d'intégrer facilement les leads achetés dans votre système de gestion de la relation client. Il vous suffit de connecter votre CRM via l'interface de la plateforme.",
            },
            {
                q: 'La plateforme propose-t-elle une API pour récupérer automatiquement les leads ?',
                a: "Oui, la plateforme propose une API qui vous permet de récupérer automatiquement les leads directement dans votre système. Cela facilite l'automatisation du processus et l'intégration des leads dans vos flux de travail existants.",
            },
            {
                q: 'Est-ce que les leads sont livrés sous forme de fichier Excel, CSV ou autre format ?',
                a: 'Les leads peuvent être livrés sous différents formats, selon votre préférence. Nous vous les envoyons généralement par e-mail sous forme de fichier CSV, mais nous pouvons aussi les intégrer directement dans votre CRM ou sur Google Sheets si vous le souhaitez.',
            },
            {
                q: 'Puis-je segmenter les leads en fonction de critères spécifiques avant de les acheter ?',
                a: 'Oui, vous pouvez segmenter les leads en fonction de critères spécifiques avant de les acheter. La plateforme vous permet de définir des critères de sélection, comme le secteur d’activité, la localisation géographique, ou d’autres paramètres, pour affiner la sélection des leads que vous souhaitez acquérir.',
            },
        ],
    },
    {
        category: 'Questions sur la protection des données',
        questions: [
            {
                q: 'Comment la plateforme protège-t-elle les données personnelles des leads ?',
                a: "La plateforme protège les données personnelles des leads en utilisant des technologies de sécurité avancées, telles que le cryptage des données pendant leur transmission et leur stockage. Nous appliquons également des protocoles stricts d'accès aux données, limitant l'accès aux seules personnes autorisées.",
            },
            {
                q: 'Que faire si je reçois des leads non conformes à la législation européenne ?',
                a: 'Si vous recevez des leads non conformes aux réglementations européennes, notamment le RGPD, vous devez contacter notre support immédiatement. Nous procéderons à une vérification avec nos partenaires.',
            },
        ],
    },
    {
        category: 'Questions sur les retours et réclamations',
        questions: [
            {
                q: 'Que faire si un lead que j’ai acheté est erroné ou invalide ?',
                a: "Si vous constatez qu'un lead acheté est erroné ou invalide, vous pouvez contacter notre support client. Nous examinerons le problème et, si le lead ne respecte pas les critères de qualité, nous vous proposerons un remplacement ou un remboursement, en fonction de nos conditions de vente.",
            },
            {
                q: 'Existe-t-il une politique de remboursement pour les leads qui ne répondent pas aux critères ?',
                a: 'Oui, nous avons une politique de remboursement ou de remplacement pour les leads qui ne respectent pas les critères définis lors de votre commande. Les conditions exactes de remboursement sont spécifiées dans nos conditions générales de vente.',
            },
            {
                q: 'Comment signaler un lead frauduleux ou incorrect ?',
                a: 'Si vous avez reçu un lead que vous estimez frauduleux ou incorrect, veuillez nous en informer immédiatement via notre support. Nous enquêterons sur la situation et prendrons les mesures appropriées pour résoudre le problème. Si nécessaire, nous procéderons à un remboursement ou à un remplacement du lead.',
            },
        ],
    },
    {
        category: 'Questions sur la performance et le suivi des leads',
        questions: [
            {
                q: 'Puis-je suivre les performances des leads que j’ai achetés ?',
                a: 'Oui, vous pouvez suivre la performance des leads achetés directement via votre tableau de bord personnel. Vous aurez accès à des informations sur l’état de chaque lead et pourrez voir les résultats de vos campagnes ou actions marketing.',
            },
            {
                q: 'La plateforme propose-t-elle des statistiques ou des rapports sur les leads achetés ?',
                a: "Oui, la plateforme propose des outils de suivi et de rapport qui vous permettent de générer des statistiques détaillées sur les leads achetés, leur conversion, leur performance et d'autres critères spécifiques selon vos objectifs.",
            },
        ],
    },
    {
        category: "Questions sur le support et l'assistance",
        questions: [
            {
                q: 'Comment contacter le support si je rencontre un problème avec un achat ?',
                a: 'Si vous avez un problème avec un achat, vous pouvez contacter notre support en envoyant un e-mail à notre adresse de support ou en utilisant le formulaire de contact sur la plateforme. Notre équipe répondra à votre demande dans les plus brefs délais.',
            },
            {
                q: 'Y a-t-il un support dédié pour les acheteurs de leads ?',
                a: 'Oui, nous avons un support dédié spécifiquement pour les acheteurs de leads. Notre équipe est là pour vous aider avec toute question ou problème concernant vos achats, la qualité des leads, les paiements ou toute autre demande.',
            },
            {
                q: 'Où puis-je trouver des guides ou des tutoriels pour mieux utiliser la plateforme ?',
                a: "Nous proposons des guides et des tutoriels détaillés dans la section 'Aide' de notre site. Vous y trouverez des ressources pour vous aider à naviguer sur la plateforme et à optimiser vos achats de leads.",
            },
        ],
    },
    {
        category: 'Questions sur les conditions et la conformité',
        questions: [
            {
                q: "Quelles sont les conditions générales d'achat des leads sur la plateforme ?",
                a: "Les conditions générales d'achat sont disponibles sur notre site dans la section 'Conditions générales'. Elles couvrent les modalités d'achat, les politiques de retour et de remboursement, ainsi que vos droits et obligations en tant qu'acheteur.",
            },
            {
                q: "Quels sont mes droits en tant qu'acheteur en cas de problème avec un lead ?",
                a: "En tant qu'acheteur, vous avez le droit d’obtenir un remplacement ou un remboursement si un lead ne respecte pas les critères définis lors de votre commande. Vous pouvez également signaler toute non-conformité ou tout problème via notre service client.",
            },
            {
                q: 'Comment savoir si les leads respectent les lois locales et les normes éthiques ?',
                a: 'La plateforme prend toutes les mesures nécessaires pour s’assurer que les leads sont collectés conformément aux lois locales, notamment le RGPD en Europe. Nous effectuons des contrôles de conformité pour garantir que les leads respectent les normes éthiques et légales en vigueur.',
            },
        ],
    },
];

const BuyerFaqPage = () => {
    return (
        <div className="mx-auto w-full max-w-6xl px-1 pb-6">
            <Card extra="w-full border border-leadrs-stroke bg-white px-6 py-6">
                <div className="flex items-start gap-3">
                    <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg bg-leadrs-yellow-soft">
                        <MdHelpOutline className="h-5 w-5 text-leadrs-yellow-focus" />
                    </div>
                    <div>
                        <h1 className="font-crimson text-2xl font-semibold leading-tight text-leadrs-text md:text-3xl">
                            Foire Aux Questions
                        </h1>
                        <p className="mt-1 font-geist text-sm text-leadrs-text-soft">
                            Retrouvez rapidement les reponses a vos questions sur les achats de leads et la gestion de votre compte.
                        </p>
                    </div>
                </div>
            </Card>

            <div className="mt-5 space-y-5">
                {faqData.map((section, idx) => (
                    <Card key={idx} extra="border border-leadrs-stroke bg-white px-5 py-5">
                        <div className="mb-4 flex items-center gap-3 border-b border-leadrs-stroke pb-3">
                            <div className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-lg bg-leadrs-brown-soft">
                                <MdOutlineQuestionAnswer className="h-4 w-4 text-leadrs-brown-focus" />
                            </div>
                            <h2 className="font-geist text-lg font-semibold text-leadrs-text md:text-xl">
                                {section.category}
                            </h2>
                            <span className="ml-auto rounded-full bg-leadrs-bg px-2.5 py-1 font-geist text-xs font-medium text-leadrs-text-soft">
                                {section.questions.length} questions
                            </span>
                        </div>

                        <div className="space-y-3">
                            {section.questions.map((item, qIdx) => (
                                <details
                                    key={qIdx}
                                    className="group rounded-xl border border-leadrs-stroke bg-leadrs-bg px-4 py-3 transition-colors hover:border-leadrs-text-soft"
                                >
                                    <summary className="cursor-pointer list-none pr-4 font-geist text-sm font-semibold text-leadrs-text md:text-base">
                                        <div className="flex items-center justify-between gap-3">
                                            <span>{item.q}</span>
                                            <span className="text-leadrs-text-soft transition-transform group-open:rotate-45">
                                                +
                                            </span>
                                        </div>
                                    </summary>
                                    <p className="mt-2 font-geist text-sm leading-relaxed text-leadrs-text-soft md:text-[15px]">
                                        {item.a}
                                    </p>
                                </details>
                            ))}
                        </div>
                    </Card>
                ))}
            </div>
        </div>
    );
};

export default BuyerFaqPage;
